export default {
  more: 'More',
  home: 'Home',
  packUp: 'Pack Up',
  todo: 'To Do',
  workbench: 'Workbench',
  // todo 这个英文文案只是占位，到时要换，中文是正确的。
  workbenchNoRecentdata: 'No Recently Used',
  // todo 这个英文文案只是占位，到时要换，中文是正确的。
  workbenchRecentUsed: 'Recently Used',
  noAccessPermission: 'No access permission',
  err: 'If you need permission, please contact: ',
  // todo 这个errGoToWorkflow英文文案只是占位，到时要换，中文是正确的。
  // errGoToWorkflow: 'If you need permission, please view: ',
  // todo 这个viewActivationProcess英文文案只是占位，到时要换，中文是正确的。
  // viewActivationProcess: 'Permission activation process',
  contact1: 'Zheqing Lu (zheqing.lu@nio.com)',
  contact2: 'Haitao Du (tony.du@nio.com)',
  loading: 'Loading...',
  globalCopyErrMsg: 'Since the number of characters exceeds {max},copying/duplication is prohibited.',
  niocall: {
    btns: {
      microphoneOn: {
        label: 'on'
      },
      microphoneOff: {
        label: 'off'
      },
      hangup: {
        label: 'Hang up'
      }
    },
    status: {
      audioOn: {
        label: 'NIOCall in processing'
      },
      callEnd: {
        label: 'NIOCall hung up'
      },
      repeatCall: {
        label: 'Already on a call, please do not repeat the call'
      },
      waitPeer: {
        label: 'Waiting for the person to accept the invitation'
      }
    },
    callParams: {
      errCode: {
        callOngoing: 'The user you dialed is on a call . Please try again later',
        calledBusy: 'User is busy, please try again later',
        callingBusy: 'Failed, you have other processing NIOCall',
        unsupportedVehicleVersion:
          'The vehicle version is too low to support NIOCall . Please contact the user by phone'
      },
      errorAndTry: {
        firLine: 'Get parameter exception, please try again later!',
        label: 'error code:'
      }
    },
    startCall: {
      noAnswerAndTry: {
        label: 'No answer at the moment, please try again later'
      },
      network: {
        disconnected: 'The network is abnormal, the connection has been interrupted',
        qualityPoor: 'The network condition is not good',
        reconnectFail: 'Automatic reconnection failed'
      },
      initFail: {
        reconnecting: 'Reconnecting automatically, please wait',
        steamInitTimeout: 'Audio initialization timed out. If the call fails, ' +
          'try 1. Hang up the current call. 2. Refresh the browser. 3. Call again.',
        label: 'Failed to initiate call!'
      }
    },
    callPanel: {
      eventDetailLink: {
        label: 'Event Details'
      },
      wearHeadphones: {
        label: 'Please wear headphones'
      }
    }
  },
  sdk: {
    location: {
      ask: 'Is "NPDS" allowed to get location information for this device?',
      confirm: 'Open',
      reject: 'Prohibition'
    }
  },
  errorPCInfo: 'Please click the button below to apply for permission under the condition of intranet/extranet connected to VPN',
  errorMolInfo: 'The mobile terminal does not support applying for permission now. Please go to NPDS on the PC to try again.',
  errorToApply: 'Apply now',
  mine: 'Mine'
}
